import { addLabels, sendCustomError } from '@otto-ec/global-resources/apm'
import { LogTransportPort } from '../../ports'

export class LogTransportApm implements LogTransportPort {
  constructor(private readonly namespaceId: string) {}

  ERROR(
    message?: string | Error,
    labels?: Record<string, string | number | boolean>
  ): void {
    if (!this.isLoggable(message, labels)) {
      return
    }

    const labelsWithErrorMessage: Record<string, string | number | boolean> = {
      ...labels,
      logLevel: 'ERROR',
    }

    if (message) {
      if (message instanceof Error) {
        labelsWithErrorMessage.errorMessage = message.message
        labelsWithErrorMessage.errorCause = JSON.stringify(message.cause)
      } else {
        labelsWithErrorMessage.errorMessage = message
      }
    }

    const preparedLabels = this.prefixLabels(labelsWithErrorMessage)

    void sendCustomError(this.namespaceId, message ?? '', preparedLabels)
  }

  INFO(
    message?: string | Error,
    labels?: Record<string, string | number | boolean>
  ) {
    if (!this.isLoggable(message, labels)) {
      return
    }
    const preparedMessage =
      typeof message === 'string'
        ? { message }
        : { message: JSON.stringify(message) }

    const preparedLabels = this.prefixLabels({
      ...(message ? preparedMessage : {}),
      ...(labels ?? {}),
      logLevel: 'INFO',
    })

    void addLabels(preparedLabels)
  }

  private isLoggable(
    message?: string | Error,
    labels?: Record<string, string | number | boolean>
  ): boolean {
    return !!(message || labels)
  }

  private prefixLabels(labels: Record<string, string | number | boolean>) {
    return Object.fromEntries(
      Object.entries(labels).map(([key, value]) => [
        `${this.namespaceId}_${key}`,
        value,
      ])
    )
  }
}
